<app-cyclops-nav></app-cyclops-nav>

<!-- Solutions Page Header with Background Video -->
<section class="cyclops header" id="home">
  <div class="header5-content">
    <div class="cyclops-header bg video-header">
      <!-- 🎥 Background Video -->
      <video autoplay muted loop playsinline class="video-bg">
        <source src="assets/images/6.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div class="video-dark-overlay"></div>

      <!-- Overlay Content -->
      <div class="video-overlay">
        <div class="container">
          <div class="row">
            <div class="col-md-10 offset-md-1">
              <div class="center-text text-center" style="justify-content: center;">
                <div>
                  <h1>
                    <span class="bold-text">Solutions </span>
                  </h1>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div class="solutions-sections">
  <section id="manufacturing">
    <div class="solutions-page">
      <h2 class="main-title">Manufacturing & Systems Integration</h2>

      <!-- Subsection -->
      <div class="subsection" (click)="toggleSection('manufacturing')" id="manufacturingSub">
        Manufacturing & Systems Integration
      </div>

      <div class="content" [class.open]="isSectionOpen.manufacturing">
        <div class="card">

          <!-- Top Images -->
          <!-- <swiper [slidesPerView]="1" [loop]="true" [autoplay]="{ delay: 3000, disableOnInteraction: false }"
            [pagination]="{ clickable: true }" [navigation]="true" class="top-images">
            <ng-template swiperSlide>
              <img src="assets/images/solutions/IMG_1044.jpeg" alt="Manufacturing Image 1" class="img-fluid rounded" />
            </ng-template>
            <ng-template swiperSlide>
              <img src="assets/images/solutions/IMG_5598.jpeg" alt="Manufacturing Image 2" class="img-fluid rounded" />
            </ng-template>
            <ng-template swiperSlide>
              <img src="assets/images/solutions/IMG_1037.jpeg" alt="Manufacturing Image 3" class="img-fluid rounded" />
            </ng-template>
            <ng-template swiperSlide>
              <img src="assets/images/solutions/IMG_5599.jpeg" alt="Manufacturing Image 4" class="img-fluid rounded" />
            </ng-template>
          </swiper> -->

          <div class="slider">
            <div class="slider-container">
              <img [src]="images[currentIndex]" alt="Slide Image" class="slide-img" />

              <!-- Controls -->
              <button class="prev" (click)="prevSlide()">&#10094;</button>
              <button class="next" (click)="nextSlide()">&#10095;</button>
            </div>

            <!-- Dots -->
            <div class="dots">
              <span *ngFor="let img of images; let i = index" [class.active]="i === currentIndex"
                (click)="goToSlide(i)">
              </span>
            </div>
          </div>

          <!-- Content Text -->
          <p>
            At CYCLOPS, manufacturing is built on precision, compliance, and mission readiness.
            By developing and producing technologies in-house, we maintain full control over
            quality, security, and performance at every stage.
          </p>
          <p>
            Our integrated approach combines production with advanced systems integration —
            ensuring that UAV platforms, surveillance technologies, and mission-critical
            electronics operate seamlessly together in the field.
          </p>

          <h4>Core Capabilities:</h4>
          <div style="color: black;">
            • PCB design, layout, and assembly (SMT/THT)<br>
            • Wire harness and cable assembly<br>
            • Full box builds and electro-mechanical assembly<br>
            • Prototype to full-scale production<br>
            • Testing, inspection, and quality assurance<br>
            • NDA-secured workflows with full traceability<br>
          </div>

          <h4>Industries Served:</h4>
          <div style="color: black;">
            • UAVs and aerial systems <br>
            • Surveillance and secure communications<br>
            • Ground control systems<br>
            • Mission-critical electronics<br>
          </div>

          <h4>Quality & Certification</h4>
          <p><strong>ISO 9001:2015 Certified</strong></p>
          <p><strong>Scope:</strong> Circuit board assembly, wire harnesses, box builds</p>


          <!-- Bottom ISO Image -->
          <div class="bottom-image" style="text-align: center; margin-top: 20px;">
            <img src="assets/images/iso.jpg" alt="ISO Certification" width="200" height="auto" class="img-fluid">
          </div>
          <p><i>Every product we build is designed for operational reliability , mission success and rapid deployment
            </i></p>
        </div>
      </div>
    </div>
  </section>
  <section id="uavs">
    <div class="solutions-page">
      <h2 class="main-title"> UAVs </h2>

      <!-- Subsection 1.1 -->

      <div class="subsection" (click)="toggleSection('shortRange')" id="short-range">
        Short Range
      </div>

      <div class="content" [class.open]="isSectionOpen.shortRange">

        <!-- Dark Phoenix Card -->
        <div class="card">
          <h4>Tactical Unmanned Combat Drones – Dark Phoenix</h4>

          <!-- Download Catalog Button -->
          <!-- <a href="assets/pdfs/2025-Buklet-Dark_Phoenix-210-210-English.pdf" download class="download-btn">
            📎 Download Catalog
          </a> -->
          <div class="pdf-list">

            <div class="pdf-item">
              <a href="assets/pdfs/2025-Buklet-Dark_Phoenix-210-210-English.pdf" target="_blank" class="view-btn"
                title="View PDF" style="padding-left: 10px;">
                <span class="material-icons">visibility</span>
              </a>
              <a href="assets/pdfs/2025-Buklet-Dark_Phoenix-210-210-English.pdf" download class="download-btn"
                title="Download PDF">
                <span class="material-icons">download</span>
              </a>
              <span class="pdf-name">Dark Phoenix Catalog</span>
            </div>
          </div>
          <!-- Image Gallery -->
          <div class="media-gallery">
            <img src="assets/images/uavs/darkPh.png" style="background-color: #700000;" alt="Dark Phoenix Drone"
              class="media-item">
            <!-- <img src="assets/images/dark-phoenix-2.jpg" alt="Dark Phoenix Side View" class="media-item">
            <img src="assets/images/dark-phoenix-3.jpg" alt="Dark Phoenix in Flight" class="media-item"> -->
          </div>

          <!-- Video Section -->
          <div class="media-videos">


           
            <video controls class="media-item">
              <source src="assets/Videos/2.mp4" type="video/mp4">
              Your browser does not support the video tag.
            </video>
          </div>
        </div>

        <!-- Tactical ISR Card -->
        <div class="card">
          <h4>Tactical ISR</h4>
          <div class="media-gallery">
            <!-- <img src="assets/images/tactical-isr-1.jpg" alt="Tactical ISR" class="media-item">
            <img src="assets/images/tactical-isr-2.jpg" alt="Tactical ISR in Operation" class="media-item"> -->
          </div>
          <div class="media-videos">
            <video controls class="media-item">
              <source src="assets/Videos/3.mp4" type="video/mp4">
            </video>
          </div>
        </div>
      </div>


      <!-- Subsection 1.2 -->
      <div class="subsection" (click)="toggleSection('mediumRange')" id="medium-range">
        Medium Range
      </div>
      <div class="content" [class.open]="isSectionOpen.mediumRange">
          <div class="pdf-list">

            <div class="pdf-item">
              <a href="assets/pdfs/DARK-DRAGON_F.pdf" target="_blank" class="view-btn"
                title="View PDF" style="padding-left: 10px;">
                <span class="material-icons">visibility</span>
              </a>
              <a href="assets/pdfs/DARK-DRAGON_F.pdf" download class="download-btn"
                title="Download PDF">
                <span class="material-icons">download</span>
              </a>
              <span class="pdf-name">DARK DRAGON</span>
            </div>

             <div class="pdf-item">
              <a href="assets/pdfs/SKY-LANCE_F.pdf" target="_blank" class="view-btn"
                title="View PDF" style="padding-left: 10px;">
                <span class="material-icons">visibility</span>
              </a>
              <a href="assets/pdfs/SKY-LANCE_F.pdf" download class="download-btn"
                title="Download PDF">
                <span class="material-icons">download</span>
              </a>
              <span class="pdf-name">SKY LANCE </span>
            </div>
          </div>
        <!-- <div class="card disabled">
          <h4>Bombers </h4>
          <p>Comming soon</p>
        </div>
        <div class="card">
          <h4>ISR – P550</h4>
          <div class="media"> Product images</div>
          <div class="media"> Promotional video </div>
        </div> -->
      </div>

      <!-- Subsection 1.3 -->
      <div class="subsection" (click)="toggleSection('longRange')" id="long-range">
        Long Range
      </div>
      <!-- <div class="content" [class.open]="isSectionOpen.longRange">
        <div class="card">
          <h4>ISR – Jump20</h4>
          <button class="download-btn">Download Spec Sheet</button>
          <div class="media"> Showcase images</div>
          <div class="media">Demo video (if available)</div>
        </div>
      </div> -->
    </div>
  </section>
  <section id="border-security">
    <!-- 🔴 BORDER SECURITY SECTION -->
    <div class="solutions-page">
      <h2 class="main-title">Border Security solutions</h2>

      <!-- Subsection: Operational Support -->
      <div class="subsection" (click)="toggleSection('ops')" id="opst">
        Operational Support & Technology
      </div>
      <div class="content" [class.open]="isSectionOpen.ops">
        <div class="card" style="color: black;">
          • Secure Tactical Communications: Encrypted, mission-critical platforms.<br>
          • Surveillance System Integration: Thermal, visual, and situational monitoring.<br>
          • AI-Driven Enhancements: Smart analytics and autonomous tools.<br>
          • Unmanned Aerial Systems (UAS/UAV): Pilot training, ISR, and deployment support.<br>
          • On-Site Technical Assistance: Readiness and integration in the field.<br>
          • Maintenance, Repair & Overhaul (MRO): Diagnostics and sustainment.<br>
        </div>
      </div>

      <!-- Subsection: Strategic Services -->
      <div class="subsection" (click)="toggleSection('strategy')" id="strategy">
        Strategic & Program Services
      </div>
      <div class="content" [class.open]="isSectionOpen.strategy">
        <div class="card" style="color: black;">
          • Defense & Security Consultancy: Planning, risk mitigation, and compliance.<br>
          • Mission Engagement & Advisory: Outreach and international coordination.<br>
          • Defense Project Management: Lifecycle planning for complex programs.<br>
          • USG & FMF/FMS Advisory: Procurement, LOR/LOA process experience, stakeholder
          coordination.<br>
        </div>
      </div>

      <!-- Subsection: Detection Systems -->
      <div class="subsection" (click)="toggleSection('detection')" id="detection">
        Detection, Surveillance & Security Systems
      </div>
      <div class="content" [class.open]="isSectionOpen.detection">
        <div class="card " style="color: black;">
          • Surveillance & Awareness: CCTV, thermal, access control.<br>
          • Perimeter & Tactical Security: Barriers, fencing, UVSS, riot control.<br>
          • Detection & Screening: Narcotics, x-ray, walkthroughs.<br>
          • Radars & Tracking Systems: Fire control, ground surveillance, multi-mission,
          on-the-move, air surveillance, airborne radars, and counter-UAS tech.<br>
          • Instrument Landing Systems: Civilian and military-grade ILS.<br>
        </div>
      </div>
    </div>
  </section>

  <section id="protective-services ">

    <div class="solutions-page">
      <h2 class="main-title">Secure Transportation & Protective Services </h2>

      <div class="subsection" (click)="toggleSection('ov')" id="ov">
        Overview
      </div>
      <div class="content" [class.open]="isSectionOpen.ov">
        <div class="card" style="color: black;">
          Cyclops provide secure transportation and protective services to support diplomatic, institutional, and
          corporate missions operating in complex and sensitive environments. Our services are designed to ensure safe
          movement, operational continuity, and mission reliability through disciplined planning, controlled mobility,
          and professional coordination.
          All services are delivered with discretion, professionalism, and adherence to international operational
          standards.

        </div>
      </div>

      <!-- Subsection: Strategic Services -->
      <div class="subsection" (click)="toggleSection('core')" id="core">
        Core Capabilities
      </div>
      <div class="content" [class.open]="isSectionOpen.core">
        <div class="card" style="color: black;">
          <p> Cyclops delivers integrated movement and protective support tailored to mission requirements, including:
          </p><br>
          • Secure ground transportation and journey coordination<br>
          • Protective support for VIPs, executives, and institutional delegations<br>
          • Cross-border movement planning and coordination<br>
          • Airport meet-and-assist and secure transfers<br>
          • Route planning, movement timing, and contingency coordination<br>
          • On-ground operational coordination and mission oversight<br>
          <p>Services are structured to support short-term engagements, official visits, and multi-day operational
            deployments.</p>

        </div>
      </div>

      <div class="subsection" (click)="toggleSection('op')" id="op">
        Operational Presence
      </div>
      <div class="content" [class.open]="isSectionOpen.op">
        <div class="card " style="color: black;">
          <p>Cyclops supports secure transportation and protective missions in select operating environments, subject
            to mission-specific planning and regulatory conditions, including:</p>
          • Syria <br>
          • Lebanon<br>
          • Libya <br>
          <p>Each deployment is planned based on local conditions, regulatory frameworks, and mission risk profiles to
            ensure safe and controlled execution.
          </p>
        </div>
      </div>
      <div class="subsection" (click)="toggleSection('am')" id="am">
        Armored Mobility
      </div>
      <div class="content" [class.open]="isSectionOpen.am">
        <div class="card " style="color: black;">
          <p> Cyclops deploys armored mobility assets to support secure movement in higher-risk environments.</p>
          <b>Capabilities include:</b>
          • Armored vehicles with protection levels up to B6/B7<br>
          <div class="images-grid">
            <img *ngFor="let img of proimages" [src]="img" alt="Armored Vehicle" class="grid-img" />
          </div>
          • Professionally trained security drivers<br>
          • Daily vehicle inspections and operational readiness checks<br>
          • Secure movement planning aligned with threat conditions<br>
          <p> Armored mobility solutions are integrated into broader journey management and mission coordination
            frameworks.
          </p>
        </div>
      </div>
      <div class="subsection" (click)="toggleSection('mg')" id="mg">
        Compliance & Mission Governance
      </div>
      <div class="content" [class.open]="isSectionOpen.mg">
        <div class="card " style="color: black;">
          <p> Cyclops structures all secure transportation and protective services in alignment with applicable
            regulatory, diplomatic, and operational requirements.</p>
          <b>This includes: </b>
          • Mission coordination in accordance with local and international frameworks<br>
          • Compliance with applicable export, licensing, and operational regulations<br>
          • Structured risk assessment and mission approval processes<br>
          • Discreet coordination with relevant authorities where required<br>
          <p>Our governance approach ensures missions are conducted responsibly, transparently, and in accordance with
            institutional standards.</p>

          <p><strong>Regions Supported: </strong>Middle East & Select International Locations </p>
          <p><strong> Service Availability:</strong> Mission-based | Institutional engagements </p>




        </div>


      </div>


    </div>
  </section>

  <section id="mro">
    <div class="solutions-page">
      <h2 class="main-title">Maintenance, Repair & Overhaul (MRO) Services</h2>

      <!-- Subsection -->
      <div class="subsection" (click)="toggleSection('mro')" id="mroSub">
        Vehicle MRO Services
      </div>

      <div class="content" [class.open]="isSectionOpen.mro">
        <div class="card">

          <div class="slider">
            <div class="slider-container">
              <img [src]="mroimages[currentIndex]" alt="Slide Image" class="slide-img" />

              <!-- Controls -->
              <button class="prev" (click)="prevmrSlide()">&#10094;</button>
              <button class="next" (click)="nextmrSlide()">&#10095;</button>
            </div>

            <!-- Dots -->
            <div class="dots">
              <span *ngFor="let img of mroimages; let i = index" [class.active]="i === currentIndex"
                (click)="goToSlide(i)">
              </span>
            </div>
          </div>

          <!-- Text Content -->
          <p>
            At CYCLOPS, we ensure that vehicles — whether military fleets, armored convoys, or civilian platforms —
            remain reliable and operational throughout their lifecycle. Our MRO services cover preventive maintenance,
            corrective repairs, and complete overhauls, with full supply chain support.
          </p>
          <p>
            With facilities in the United States and the Middle East, CYCLOPS provides both domestic and in-theater
            sustainment, reducing downtime and ensuring vehicles remain compliant with international standards.
          </p>

          <h4>Core Capabilities</h4>
          <div style="color: black;">
            • Preventive and corrective maintenance for light, heavy, and tactical vehicles<br>
            • Overhaul and sustainment of armored vehicles (B6/B7 protection level)<br>
            • Diagnostics, testing, and performance upgrades<br>
            • Spare parts sourcing and supply chain management<br>
            • Complete refurbishment and lifecycle extension<br>
            • Rapid in-theater sustainment and readiness support<br>
          </div>
          <h4>Our Facilities</h4>
          <p><strong>MRO Facility – United States:</strong> Providing full vehicle sustainment, overhauls, and
            compliance testing to support domestic programs.</p>
          <p><strong>MRO Facility – Middle East:</strong> Delivering in-theater maintenance and rapid-response support
            for military fleets, armored convoys, and civilian platforms.</p>

          <!-- Bottom Image (full-width WhatsApp photo placeholder) -->
          <div class="bottom-image" style="text-align: center; margin-top: 20px;">
            <img src="assets/images/MRO/mrous.jpg" alt="MRO Facility" width="70%" class="img-fluid rounded">
          </div>

          <p style="margin-top: 20px;"> <i>
              Every vehicle we service — from civilian fleets to B6/B7 armored platforms — is maintained to the highest
              standards of reliability, safety, and mission readiness across the United States and the Middle East.
            </i> </p>

        </div>
      </div>
    </div>
  </section>
  <section id="sdo">
    <div class="solutions-page">
      <h2 class="main-title">Strategic Advisory & Operational Support</h2>

      <!-- Subsection -->
      <div class="subsection" (click)="toggleSection('sdo')" id="sdoSub">
        Strategic Advisory & Operational Support
      </div>

      <div class="content" [class.open]="isSectionOpen.sdo">
        <div class="card">

          <!-- slider Content -->


          <!-- Text Content -->
          <p>
            CYCLOPS supports government and defense partners with program development, international market engagement,
            and operational coordination across domestic and global markets. We assist clients in structuring
            initiatives, aligning stakeholder engagement, and supporting effective implementation within regulatory and
            operational frameworks.
          </p>
          

          <h4>Core Areas of Support</h4>
          <div style="color: black;">
            • International market entry and partner engagement<br>
            • Government coordination support<br>
            • Program development and implementation guidance<br>
            • Secure systems integration advisory<br>
            • Operational planning support<br>
          
          </div>
          
        

        </div>
      </div>
    </div>
  </section>
  <section id="isr">
    <div class="solutions-page">
      <h2 class="main-title">Tactical, MANET & ISR Solutions</h2>

      <!-- Subsection: Datasheets -->
      <div class="subsection" (click)="toggleSection('isrDatasheets')" id="isr-datasheets">
        Datasheets
      </div>
      <div class="content" [class.open]="isSectionOpen.isrDatasheets">
        <div class="card">
          <h4>MANET Datasheets</h4>
          <!-- Dynamic PDF List -->
          <div class="pdf-list">
            <div *ngFor="let pdf of manetPdfs" class="pdf-item">
              <a [href]="pdf.path" target="_blank" class="view-btn" title="View PDF" style="padding-left: 10px;">
                <span class="material-icons">visibility</span>
              </a>
              <a [href]="pdf.path" download class="download-btn" title="Download PDF">
                <span class="material-icons">download</span>
              </a>
              <span class="pdf-name">{{ pdf.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Subsection: Media -->
      <div class="subsection" (click)="toggleSection('isrMedia')" id="isr-media">
        Media
      </div>
      <div class="content" [class.open]="isSectionOpen.isrMedia">
        <div class="card">
          <!-- <h4>Media Gallery</h4>
          <div class="media-gallery">
            <img src="assets/images/isr1.jpg" alt="ISR Image 1" class="media-item">
            <img src="assets/images/isr2.jpg" alt="ISR Image 2" class="media-item">
          </div> -->
          <div class="media-videos">
            <video controls class="media-item">
              <source src="assets/Videos/manet/Drone-IMSI-Cyclops.mp4" type="video/mp4">
              Your browser does not support the video tag.
            </video>
            <video controls class="media-item">
              <source src="assets/Videos/manet/Thai-Marine-Cyclops.mp4" type="video/mp4">
              Your browser does not support the video tag.
            </video>
          </div>
          <!-- <div class="media-videos">
            <video controls class="media-item">
              <source src="assets/Videos/manet/Drone-IMSI-Cyclops.mp4" type="video/mp4">
              Your browser does not support the video tag.
            </video>
            <video controls class="media-item">
              <source src="assets/Videos/manet/Thai-Marine-Cyclops.mp4" type="video/mp4">
              Your browser does not support the video tag.
            </video>
          </div> -->
        </div>
      </div>
    </div>
  </section>





  <section id="licensing">
    <div class="solutions-page">
      <h2 class="main-title">Licensing, Compliance & Export Consulting</h2>

      <!-- Subsection: Operational Support -->
      <div class="subsection" (click)="toggleSection('licensing')" id="licensingsub">
        Licensing, Compliance & Export Consulting
      </div>
      <div class="content" [class.open]="isSectionOpen.licensing">
        <div class="card" style="color: black;">
          • DSP-5: Export of unclassified defense items.<br>
          • DSP-73: Temporary export for demos, training, or repairs.<br>
          • TAA: Technical Assistance Agreements for data and services.<br>
          • DS-4294: Brokering registration and submissions.<br>
          • Export Compliance Support: FMF, FMS, and DCS guidance.<br>
        </div>
      </div>

    </div>
  </section>







</div>

<app-cyclops-footer></app-cyclops-footer>